import React from 'react';

import { Search, Input } from './styles';

const SearchInput = ({ ...props }) => (
  <Search {...props}>
    <Input {...props} />
  </Search>
);

export default SearchInput;
